import { LuTicket, LuUserRoundPlus, LuUsers } from "react-icons/lu";
import { Edition } from "./edition";
import { TableLayout } from "../../layouts/table";
import { CollectionSummary } from "../../../../components/collectionTools";
import { ClientList } from "./clientList";
import { getClientList } from "./clientListModel";
import "./style.css";
export const Clients = () => (
  <section className="catalogsReference clientsReference">
    <TableLayout
      title="Clientes"
      edition={<Edition />}
      get={getClientList}
      idKey="customerId"
      identificator="clients"
      headerAction={
        <button
          className="clientNewButton"
          type="button"
          disabled
          title="El alta de clientes desde este panel aún no está disponible"
        >
          <LuUserRoundPlus aria-hidden="true" /> Nuevo cliente
        </button>
      }
      renderSummary={(rows) => (
        <CollectionSummary
          items={[
            {
              label: "Clientes registrados",
              icon: <LuUsers />,
              value: rows.length,
            },
            {
              label: "Nuevos este mes",
              icon: <LuUserRoundPlus />,
              value: "—",
              detail: "Fecha de alta no disponible en este listado",
            },
            {
              label: "Con pedidos activos",
              icon: <LuTicket />,
              value: "—",
              detail: "Estado de pedidos disponible en cada ficha",
            },
          ]}
        />
      )}
      renderContent={(rows, onEdit) => (
        <ClientList rows={rows} onEdit={onEdit} />
      )}
    />
  </section>
);
